import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarItinerarioEmbarque from '../../actions/itinerario/adicionarItinerarioEmbarque'
import removerFiltroItinerarioEmbarque from '../../actions/itinerario/removerFiltroItinerarioEmbarque'

import CampoBusca from '../comum/CampoBusca'


export class CampoBuscaItinerarioEmbarque extends Component {
  render () {
    return (
      <React.Fragment>
        <CampoBusca
          filtrosAdicionados={this.props.filtrosAdicionadosProcesso}
          adicionarFiltro={this.props.adicionarItinerarioEmbarque}
          removerFiltro={this.props.removerFiltroItinerarioEmbarque}/>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = ({ filtrosAdicionadosProcesso }) => ({ filtrosAdicionadosProcesso });

export const mapDispatchToProps = dispatch => bindActionCreators({
  adicionarItinerarioEmbarque,
  removerFiltroItinerarioEmbarque
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CampoBuscaItinerarioEmbarque)
